<script setup>
import { Head } from '@inertiajs/vue3'
import PublicLayout from '@/Layouts/PublicLayout.vue'
import { journal } from '@/data/content.js'

defineOptions({ layout: PublicLayout })
</script>

<template>
  <Head>
    <title>Journal · Kenya2Go</title>
    <meta name="description" content="Stories, guides and field notes from Kenya — wildlife, food, culture and the practical stuff.">
  </Head>

  <div class="kp">
    <header class="kp-hero">
      <div class="kp-hero__inner">
        <p class="kp-eyebrow">Journal</p>
        <h1 class="kp-hero__title">Field notes from Kenya</h1>
        <p class="kp-hero__lede">Stories, guides and honest advice — written by people who spend their lives showing visitors this country.</p>
      </div>
    </header>

    <section class="kp-section">
      <div class="jgrid">
        <a v-for="p in journal" :key="p.slug" class="kp-card jcard" :href="`/journal/${p.slug}`" :style="{ '--h': p.hue }">
          <div class="kp-art jcard__art">
            <span class="jcard__cat">{{ p.category }}</span>
          </div>
          <div class="jcard__body">
            <h2 class="jcard__title">{{ p.title }}</h2>
            <p class="jcard__dek">{{ p.dek }}</p>
            <p class="jcard__meta">{{ p.date }} · {{ p.readMins }} min read</p>
          </div>
        </a>
      </div>
    </section>
  </div>
</template>

<style scoped>
.jgrid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.4rem; }
.jcard__art { height: 160px; display: flex; align-items: flex-start; padding: 0.8rem; }
.jcard__cat { position: relative; z-index: 1; font-size: 0.68rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: oklch(0.99 0.02 85); background: oklch(0.2 0.04 40 / 0.3); padding: 0.25rem 0.6rem; border-radius: 999px; }
.jcard__body { padding: 1.1rem 1.2rem 1.3rem; }
.jcard__title { font-family: var(--display); font-weight: 500; font-size: 1.35rem; line-height: 1.1; margin: 0 0 0.5rem; color: var(--ink); }
.jcard__dek { font-size: 0.94rem; line-height: 1.5; color: var(--inkSoft); margin: 0 0 0.8rem; }
.jcard__meta { font-size: 0.8rem; color: var(--muted); margin: 0; }
@media (max-width: 860px) { .jgrid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 560px) { .jgrid { grid-template-columns: 1fr; } }
</style>
